import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, XIcon } from 'lucide-react';
interface CommandPaletteProps {
  onClose: () => void;
}
const commands = [{
  label: 'Dashboard',
  path: '/dashboard',
  category: 'Navigate'
}, {
  label: 'Content Ideas',
  path: '/content-ideas',
  category: 'Navigate'
}, {
  label: 'Post Composer',
  path: '/post-composer',
  category: 'Navigate'
}, {
  label: 'Campaigns',
  path: '/campaigns',
  category: 'Navigate'
}, {
  label: 'Local Intelligence',
  path: '/local-intelligence',
  category: 'Navigate'
}, {
  label: 'Collaboration',
  path: '/collaboration',
  category: 'Navigate'
}, {
  label: 'Analytics',
  path: '/analytics',
  category: 'Navigate'
}, {
  label: 'Settings',
  path: '/settings',
  category: 'Navigate'
}, {
  label: 'Generate Post Idea',
  path: '/content-ideas',
  category: 'Actions'
}, {
  label: 'Create Campaign',
  path: '/campaigns',
  category: 'Actions'
}, {
  label: 'Compose Post',
  path: '/post-composer',
  category: 'Actions'
}];
export function CommandPalette({
  onClose
}: CommandPaletteProps) {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const filtered = commands.filter(cmd => cmd.label.toLowerCase().includes(search.toLowerCase()));
  const handleSelect = (path: string) => {
    navigate(path);
    onClose();
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-start justify-center pt-32" onClick={onClose} data-id="element-26">
      <motion.div initial={{
      scale: 0.95,
      y: -20
    }} animate={{
      scale: 1,
      y: 0
    }} exit={{
      scale: 0.95,
      y: -20
    }} onClick={e => e.stopPropagation()} className="w-full max-w-2xl bg-white dark:bg-gray-900 rounded-2xl shadow-2xl overflow-hidden border border-gray-200 dark:border-gray-800" data-id="element-27">
        <div className="flex items-center gap-3 px-4 py-4 border-b border-gray-200 dark:border-gray-800" data-id="element-28">
          <SearchIcon className="w-5 h-5 text-gray-400" data-id="element-29" />
          <input type="text" placeholder="Search commands..." value={search} onChange={e => setSearch(e.target.value)} autoFocus className="flex-1 bg-transparent outline-none text-gray-900 dark:text-white placeholder-gray-400" data-id="element-30" />
          <button onClick={onClose} className="p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-31">
            <XIcon className="w-5 h-5 text-gray-400" data-id="element-32" />
          </button>
        </div>
        <div className="max-h-96 overflow-y-auto p-2" data-id="element-33">
          {filtered.length === 0 ? <div className="py-8 text-center text-gray-500 dark:text-gray-400" data-id="element-34">
              No results found
            </div> : filtered.map((cmd, idx) => <button key={idx} onClick={() => handleSelect(cmd.path)} className="w-full flex items-center justify-between px-4 py-3 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-left" data-id="element-35">
                <div data-id="element-36">
                  <p className="font-medium text-gray-900 dark:text-white" data-id="element-37">
                    {cmd.label}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-38">
                    {cmd.category}
                  </p>
                </div>
              </button>)}
        </div>
      </motion.div>
    </motion.div>;
}